"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TimeDifferenceBefore = exports.TimeDifferenceAfter = exports.TimeDifferenceString = exports.TimeDifferenceDisplay = undefined;

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2, _class3, _temp3, _class4, _temp4, _class5, _temp6; /**
                                                                                        * Copyright 2013-present, Novivia, Inc.
                                                                                        * All rights reserved.
                                                                                        */

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeDifferenceDisplay = exports.TimeDifferenceDisplay = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TimeDifferenceDisplay, _Component);

  function TimeDifferenceDisplay() {
    (0, _classCallCheck3.default)(this, TimeDifferenceDisplay);
    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceDisplay)).apply(this, arguments));
  }

  (0, _createClass3.default)(TimeDifferenceDisplay, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return TimeDifferenceDisplay;
}(_react.Component), _class.__isTimeDifferenceDisplay = true, _temp);
var TimeDifferenceString = exports.TimeDifferenceString = (_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(TimeDifferenceString, _Component2);

  function TimeDifferenceString() {
    (0, _classCallCheck3.default)(this, TimeDifferenceString);
    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceString.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceString)).apply(this, arguments));
  }

  (0, _createClass3.default)(TimeDifferenceString, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        "span",
        null,
        _react2.default.Children.map(this.props.children, function (child) {
          // TODO: use context in 0.14.
          if (child && child.type && child.type.__isTimeDifferenceDisplay) {
            return _this3.props.renderTimeDifference(child.props.noWords);
          }

          return child;
        })
      );
    }
  }]);
  return TimeDifferenceString;
}(_react.Component), _class2.propTypes = {
  // Any type of children is accepted, but some will get interpolated based on
  // the time difference.
  children: _propTypes2.default.oneOfType([_propTypes2.default.node.isRequired, _propTypes2.default.arrayOf(_propTypes2.default.node.isRequired).isRequired]),

  // Time difference, only for retransmission.
  renderTimeDifference: _propTypes2.default.func
}, _temp2);
var TimeDifferenceAfter = exports.TimeDifferenceAfter = (_temp3 = _class3 = function (_TimeDifferenceString) {
  (0, _inherits3.default)(TimeDifferenceAfter, _TimeDifferenceString);

  function TimeDifferenceAfter() {
    (0, _classCallCheck3.default)(this, TimeDifferenceAfter);
    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceAfter.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceAfter)).apply(this, arguments));
  }

  return TimeDifferenceAfter;
}(TimeDifferenceString), _class3.__isTimeDifferenceAfter = true, _temp3);
var TimeDifferenceBefore = exports.TimeDifferenceBefore = (_temp4 = _class4 = function (_TimeDifferenceString2) {
  (0, _inherits3.default)(TimeDifferenceBefore, _TimeDifferenceString2);

  function TimeDifferenceBefore() {
    (0, _classCallCheck3.default)(this, TimeDifferenceBefore);
    return (0, _possibleConstructorReturn3.default)(this, (TimeDifferenceBefore.__proto__ || (0, _getPrototypeOf2.default)(TimeDifferenceBefore)).apply(this, arguments));
  }

  return TimeDifferenceBefore;
}(TimeDifferenceString), _class4.__isTimeDifferenceBefore = true, _temp4);
var TimeDifference = (_temp6 = _class5 = function (_Component3) {
  (0, _inherits3.default)(TimeDifference, _Component3);

  function TimeDifference() {
    var _ref;

    var _temp5, _this6, _ret;

    (0, _classCallCheck3.default)(this, TimeDifference);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp5 = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDifference.__proto__ || (0, _getPrototypeOf2.default)(TimeDifference)).call.apply(_ref, [this].concat(args))), _this6), _this6.targetDate = (0, _moment2.default)(new Date(_this6.props.targetDate)), _this6.tick = function (initialRender) {
      var diff = _this6.targetDate.diff();
      _this6.setState({ diff: diff });

      if (!initialRender) {
        setTimeout(_this6.tick, _this6.getNextTimerInterval(diff));
      }
    }, _this6.interpolateChild = function (child) {
      return (0, _react.cloneElement)(child, {
        renderTimeDifference: _this6.renderTimeDifference
      });
    }, _this6.renderTimeDifference = function () {
      var noWords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this6.props.noWords;

      return _this6.targetDate.fromNow(noWords);
    }, _temp5), (0, _possibleConstructorReturn3.default)(_this6, _ret);
  }

  // See: http://momentjs.com/docs/#/displaying/fromnow/


  // Utility children components that can be interpolated.


  (0, _createClass3.default)(TimeDifference, [{
    key: "componentWillMount",


    /*
     * Calculate the initial difference with the date. (Both client & server)
     */
    value: function componentWillMount() {
      this.tick(true);
    }

    /*
     * Start the refresh difference + schedule timer update sequence.
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tick();
    }

    /*
     * Determines the maximum amount of time (in milliseconds) that we can wait
     * before the next render, knowing the render wouldn't be different if we did
     * it again before that moment.
     */

  }, {
    key: "getNextTimerInterval",
    value: function getNextTimerInterval(diff) {
      var absDiff = Math.abs(diff);
      var lastGoodInterval = void 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(TimeDifference.TIME_INTERVALS), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref2 = _step.value;

          var _ref3 = (0, _slicedToArray3.default)(_ref2, 2);

          var interval = _ref3[0];
          var jump = _ref3[1];

          // Find in-between which intervals we are.
          if (absDiff <= interval) {
            // Before first interval.
            if (!lastGoodInterval) {
              return jump;
            }

            // Depending on whether we are going away (up) from a date in the past,
            // or going towards (down) a date in the future, set the timer such that
            // the next time it updates should be when the string output by Moment
            // is different from the current one.
            return diff > 0 ? jump - absDiff % jump : Math.min(jump, absDiff - lastGoodInterval);
          }

          lastGoodInterval = interval;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    /*
     * Updates the diff for the target date and schedules the next tick.
     */


    /*
     * Takes an existing ReactElement and rerenders it with the
     * `timeDifferenceString` property.
     */


    /*
     * Renders the time difference as a human-readable string.
     */

  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      // No children, just render the time difference into a span.
      if (_react2.default.Children.count(this.props.children) === 0) {
        return _react2.default.createElement(
          "span",
          null,
          this.renderTimeDifference()
        );
      }

      // Replace children we need to (TimeDifferenceAfter/TimeDifferenceBefore),
      // don't change others.
      return _react2.default.createElement(
        "span",
        null,
        _react2.default.Children.map(this.props.children, function (child) {
          // TODO: use context in 0.14.
          if (child && child.type) {
            if (child.type.__isTimeDifferenceAfter) {
              if (_this7.state.diff < 0) {
                return _this7.interpolateChild(child);
              }

              return null;
            } else if (child.type.__isTimeDifferenceBefore) {
              if (_this7.state.diff >= 0) {
                return _this7.interpolateChild(child);
              }

              return null;
            }
          }

          return child;
        })
      );
    }
  }]);
  return TimeDifference;
}(_react.Component), _class5.propTypes = {
  // Any type of children is accepted, but some will get interpolated based on
  // the time difference.
  children: _propTypes2.default.oneOfType([_propTypes2.default.node.isRequired, _propTypes2.default.arrayOf(_propTypes2.default.node.isRequired).isRequired]),

  // If true, Moment will not render words like "in" or "ago".
  noWords: _propTypes2.default.bool,

  // Date to calculate difference against.
  targetDate: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date).isRequired, _propTypes2.default.string.isRequired]).isRequired
}, _class5.TIME_INTERVALS = new _map2.default([
// Up to 45 seconds, 1 second intervals.
[45 * 1000, 1 * 1000],

// Up to 45 minutes, 1 minute intervals.
[45 * 60 * 1000, 60 * 1000],

// Up to 22 hours, 1 hour intervals.
[22 * 60 * 60 * 1000, 60 * 60 * 1000],

// Up to 25 days, 1 day intervals.
[25 * 24 * 60 * 60 * 1000, 24 * 60 * 60 * 1000],

// Everything above, 24 day intervals.
[Infinity, 24 * 24 * 60 * 60 * 1000]]), _class5.Display = TimeDifferenceDisplay, _class5.After = TimeDifferenceAfter, _class5.Before = TimeDifferenceBefore, _temp6);
exports.default = TimeDifference;


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/TimeDifference.jsx
// module id = 860
// module chunks = 15